import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

export default function LanguageToggle({ variant = "ghost", size = "sm", className = "", iconOnly = false }) {
  const { t, toggleLang } = useI18n();

  return (
    <Button
      variant={variant}
      size={iconOnly ? "icon" : size}
      onClick={toggleLang}
      className={`${iconOnly ? "h-9 w-9" : "gap-1.5"} ${className}`}
      title={t("lang.current")}
      aria-label={t("lang.switch")}
    >
      <Globe className="w-4 h-4" />
      {!iconOnly && <span className="text-xs font-medium">{t("lang.switch")}</span>}
    </Button>
  );
}
